export const navigations = [
    { to: '/billing', name: 'billing.billingSummary.header' },
    { to: '/billing/history', name: 'billing.history.header' },
    { to: '/billing/automatic-payments', name: 'billing.automaticPayments.header' },
    { to: '/billing/payment-methods', name: 'billing.paymentMethods.header' }
];
